import { useQuery } from "react-query";
import { API } from "../../utils/AxiosInstance";
import { jotFormKeys } from "./types";

export function useJotForm(id: string) {
    return useQuery(
        jotFormKeys.form(id),
        async () => {
            const { data } = await API.get<{ url: string }>(`/jot_forms/${id}`);
            return data;
        },
        {
            retry: false,
        }
    );
}
